import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchCustomer = (id: string) => {
  return useQuery({
    queryKey: ['referralCustomer', id],
    queryFn: () => api.referral.fetchCustomerItem(id),
    enabled: false, // Запрос выполняется только по требованию
  })
}
